const image = {
    maxWidth: { value: '100%' },
    height: { value: 'auto' },
    objectFit: { value: 'initial' },
    objectPosition: { value: 'initial' },
};

export { image };
